module.exports = __webpack_public_path__ + "src/images/measurements/wristCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/wristCircumference.jpg
// module id = 1165
// module chunks = 0